import Ext from 'Ext'
import $ from 'jquery'
import _ from 'underscore'
import messageResource from '../../../messageResource'
import {escapeHtmlSymbols, trim} from '../../../atUtils'
import {imgPath} from '../../../atBrowserUtils'

export const ValidationResult = {
    VALID: 'valid',
    EMPTY_RATE: 'emptyRate',
    INVALID_RATE: 'invalidRate',
}

const LeaveRatesEditorComponent = function(config) {
    LeaveRatesEditorComponent.superclass.constructor.call(this, config);
    this.numberFormatter = config.numberFormatter;
    this.floatNumberValidator = config.floatNumberValidator;
    this.maxRate = config.maxRate;
    this.addEvents("okclick");
    this.addEvents("cancelclick");
}

Ext.extend( LeaveRatesEditorComponent, Ext.Component, {

    activeLeaveTypes: [],
    inputMap: {},
    defValTdMap: {},

    onRender: function( container, position )
    {
        const self = this;

        const mainDiv = document.createElement("div");

        this.el = Ext.get(mainDiv);

        $(mainDiv).html(
            '<table class="leaveRatesTable">' +
            '   <thead class="header">' +
            '       <tr class="headerRow">' +
            '           <th class="leaveTypeName">' + messageResource.getMessage('user.add_edit.js.rates_editor.leave_rates.header.leave_type') + '</th>' +
            '           <th class="icon"></th>' +
            '           <th class="rate">' + messageResource.getMessage('user.add_edit.js.rates_editor.leave_rates.header.rate') + '</th>' +
            '           <th class="default">' + messageResource.getMessage('user.add_edit.js.rates_editor.leave_rates.header.default') + '</th>' +
            '       </tr>' +
            '   </thead>' +
            '   <tbody class="leaveRatesList"/>' +
            '   <tfoot class="footer"/>' +
            '</table>'
        )

        this.inputMap = {};

        const $leaveRatesList = $(mainDiv).find('.leaveRatesList')

        for( let i = 0; i < this.activeLeaveTypes.length; i++ )
        {
            const leaveType = this.activeLeaveTypes[i];
            const leaveTypeName = escapeHtmlSymbols(leaveType.name);

            const leaveRateRow = $(
                '<tr class="leaveRateRow">'+
                '   <td class="leaveTypeName" title="' + leaveTypeName + `">` + leaveTypeName + '</td>' +
                '   <td class="icon">' +
                '       <img class="iconImg"/>' +
                '   </td>' +
                '   <td class="rate">' +
                '       <div class="rateCellWrapper">' +
                '           <input maxlength="8"/>' +
                '           <div class="clearIcon"/>' +
                '       </div>' +
                '   </td>' +
                '   <td class="default"/>' +
                '</tr>'
            )

            leaveRateRow.find('.iconImg').attr('src', imgPath("leave_types/icons/leave_type_" + leaveType.iconId + "_24bit.png"))
            const $rateInput = leaveRateRow.find('input')

            $rateInput.attr('placeholder', messageResource.getMessage('user.add_edit.js.rates_editor.rate.placeholder'))
            this.initRateInput($rateInput, leaveRateRow.find('.clearIcon'));
            this.inputMap[leaveType.id] = $rateInput[0];

            this.defValTdMap[leaveType.id] = leaveRateRow.find('.default')[0];


            $leaveRatesList.append(leaveRateRow)
        }

        const $footer = $(mainDiv).find('.footer').append($(
            '<tr>'+
            '   <td colspan=4>' +
            '       <div class="preFooter">' +
            '           <div class="message"/>' +
            '           <div class="clearAllButton">' +
            '               <div class="clearIcon"/>' +
            '               <span class="clearAllLabel">' + messageResource.getMessage('user.add_edit.js.rates_editor.clear_all') + '</span>' +
            '           </div>' +
            '       </div>' +
            '   </td>' +
            '</tr>' +
            '<tr>'+
            '   <td colspan=4>' +
            '       <div class="buttons">' +
            '           <div class="components_button okButton">' + messageResource.getMessage("common.ok") + '</div>' +
            '           <div class="components_button cancelButton">' + messageResource.getMessage("common.cancel") + '</div>' +
            '       </div>' +
            '   </td>' +
            '</tr>'
        ));

        this.$message = $footer.find('.message')

        $footer.find('.clearIcon, .clearAllLabel').click(() => self.clearAll())
        $footer.find('.okButton').click(() => self.onOkClick())
        $footer.find('.cancelButton').click(() => self.fireEvent("cancelclick"))

        container.dom.insertBefore( mainDiv, position );
    },

    initRateInput: function($input, $clearButton) {
        $input.on('input', () => this._handleInputChange($input, $clearButton))
              .on('focus', () => {
                  $input.removeClass('invalid')
                  this._handleInputChange($input, $clearButton)
              })
              .on('blur', () => this._handleInputBlur($input, $clearButton))

        $clearButton
            .mousedown(e => e.preventDefault())
            .click(() => {
                $input.val('').removeClass('invalid').removeAttr('title').focus()
            })
    },

    _handleInputChange: function($input, $clearButton) {
        const value = trim($input.val())
        $clearButton.toggle(value.length > 0)
    },

    _handleInputBlur: function($input, $clearButton) {
        $input.val(trim($input.val()))
        if( this.prevValue !== $input.val() )
        {
            this.hasNotEmptyValue = this.hasNotEmptyValue || $input.val().length > 0;
            this.validate($input[0], this.hasNotEmptyValue || this.regularRateSpecified);
        }

        $clearButton.hide()
    },

    setUp: function(leaveRatesArray, regularRate, isEmptyValid)
    {
        Object.keys(this.inputMap).forEach(p => this.inputMap[p].value = "")
        this.$message.empty()
        this.leaveRatesArray = leaveRatesArray
        this.hasNotEmptyValue = false
        this.isEmptyValid = isEmptyValid

        if( leaveRatesArray )
        {
            for( let i = 0; i < leaveRatesArray.length; i++ )
            {
                const leaveRate = leaveRatesArray[i];
                const input = this.inputMap[ leaveRate.leaveTypeId ];
                if( input )
                {
                    if( leaveRate.rate !== undefined && leaveRate.rate != null )
                        input.value = trim(String(leaveRate.rate));
                    this.hasNotEmptyValue = this.hasNotEmptyValue || input.value.length > 0;
                    input.prevValue = input.value;
                }
            }
        }

        this.regularRateSpecified = _.isNumber(regularRate);

        const self = this;
        for( let l = 0; l < this.activeLeaveTypes.length; l++ )
        {
            const leaveType = this.activeLeaveTypes[l];
            const defTd = this.defValTdMap[ leaveType.id ];
            if(this.regularRateSpecified)
            {
                const defaultValue = this.numberFormatter.format( regularRate * leaveType.rateCoefficient );
                const a = document.createElement("a");
                a.innerHTML = defaultValue;
                a.val = defaultValue;
                a.ltId = leaveType.id;
                a.onclick = function()
                {
                    const input = self.inputMap[ this.ltId ];
                    input.value = this.val;
                    self.validate( input, true );
                };
                defTd.innerHTML = "";
                defTd.appendChild( document.createTextNode("( ") );
                defTd.appendChild( a );
                defTd.appendChild( document.createTextNode(" )" ) );
            }
            else
            {
                defTd.innerHTML = "( " + messageResource.getMessage("common.not_available_lower") + " )";
            }
        }

        this.validateAll()
    },

    validate: function( input, emptyIsNotValid )
    {
        let validationResult = ValidationResult.VALID

        const normalizedValue = this.numberFormatter.normalize(input.value)
        if( input.value.length === 0 )
        {
            if( emptyIsNotValid)
            {
                input.className = "invalid"
                input.title = messageResource.getMessage("user.add_edit.js.rates_editor.empty_rate")
                validationResult = ValidationResult.EMPTY_RATE
            }
            else
            {
                input.className = null
                input.removeAttribute("title")
            }
        }
        else if (this.floatNumberValidator.isValidNumber(normalizedValue) && this.floatNumberValidator.parseFloat(normalizedValue) < this.maxRate)
        {
            const val = this.floatNumberValidator.parseFloat( normalizedValue );
            input.value = this.numberFormatter.format( val );
            input.className = null;
            input.removeAttribute("title");
        }
        else
        {
            input.className = "invalid"
            input.title = messageResource.getMessage("user.add_edit.js.rates_editor.invalid_rate", [this.maxRate])
            validationResult = ValidationResult.INVALID_RATE
        }

        return validationResult
    },

    clearAll: function() {
        Object.keys(this.inputMap).forEach(p => {
            this.inputMap[p].value = ""
            this.inputMap[p].className = null
            this.inputMap[p].removeAttribute("title")
        })
        this.hasNotEmptyValue = false
        this.$message.empty()
    },

    onOkClick: function() {
        const validationResult = this.validateAll()
        if (!validationResult[ValidationResult.EMPTY_RATE] && !validationResult[ValidationResult.INVALID_RATE]) {
            this.fireEvent("okclick")
        } else {
            this.updateMessage(validationResult)
        }
    },

    validateAll: function() {
        let result = {}

        Object.keys(this.inputMap).forEach(t => {
            result[this.validate(this.inputMap[t], this.hasNotEmptyValue || !this.isEmptyValid)] = true
        })

        this.updateMessage(result)

        return result
    },

    updateMessage: function(validationResult) {
        if (!validationResult[ValidationResult.EMPTY_RATE] && !validationResult[ValidationResult.INVALID_RATE]){
            this.$message.empty()
        } else if (validationResult[ValidationResult.EMPTY_RATE] && !validationResult[ValidationResult.INVALID_RATE]){
            this.$message.text(messageResource.getMessage('user.add_edit.js.rates_editor.error.empty_rate'))
        } else if (!validationResult[ValidationResult.EMPTY_RATE] && validationResult[ValidationResult.INVALID_RATE]){
            this.$message.text(messageResource.getMessage('user.add_edit.js.rates_editor.error.invalid_rate'))
        } else {
            this.$message.text(messageResource.getMessage('user.add_edit.js.rates_editor.error.correct_errors'))
        }
    },

    getLeaveRates: function()
    {
        const leaveRates = [];

        Object.keys(this.inputMap).forEach(leaveTypeId => leaveRates.push({leaveTypeId, rate: this.inputMap[leaveTypeId].value}))
        return leaveRates;
    },

})

export default LeaveRatesEditorComponent



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/ratesEditor/LeaveRatesEditorComponent.js